import { render, staticRenderFns } from "./ApprovalStatusButton.vue?vue&type=template&id=5e93b811&scoped=true&"
import script from "./ApprovalStatusButton.vue?vue&type=script&lang=js&"
export * from "./ApprovalStatusButton.vue?vue&type=script&lang=js&"
import style0 from "./ApprovalStatusButton.vue?vue&type=style&index=0&id=5e93b811&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e93b811",
  null
  
)

export default component.exports